import React from 'react';
import { 
  Microscope, 
  Syringe, 
  CheckCircle2,
  Timer,
  Shield,
  Stethoscope,
  ArrowUpDown,
  Zap,
  Scale,
  User
} from 'lucide-react';
import './Dto43d2.css';

const Dto43d2: React.FC = () => {
  return (
    <div className="dto43d2">
      {/* Hero Section */}
      <div className="hero">
        <div className="hero-overlay"></div>
        <div className="hero-content">
          <h1>Advanced Root Canal Treatment</h1>
          <p>Comparing Traditional vs. Microscope-Assisted Techniques</p>
        </div>
      </div>

      {/* Treatment Comparison */}
      <section className="comparison-section container">
        <h2 className="section-title">Treatment Comparison</h2>
        <div className="comparison-grid">
          <div className="comparison-card">
            <h3>Conventional Treatment</h3>
            <ul className="comparison-list">
              <li>
                <User className="list-icon" />
                <div>
                  <strong>Provider:</strong>
                  <span>General dentist</span>
                </div>
              </li>
              <li>
                <Scale className="list-icon" />
                <div>
                  <strong>Success Rate:</strong>
                  <span>60-70%</span>
                </div>
              </li>
              <li>
                <Stethoscope className="list-icon" />
                <div>
                  <strong>Visualization:</strong>
                  <span>Naked eye observation</span>
                </div>
              </li>
              <li>
                <Timer className="list-icon" />
                <div>
                  <strong>Recovery:</strong>
                  <span>Longer healing period</span>
                </div>
              </li>
            </ul>
          </div>

          <div className="comparison-card highlight">
            <h3>Microendodontic Treatment</h3>
            <ul className="comparison-list">
              <li>
                <User className="list-icon" />
                <div>
                  <strong>Provider:</strong>
                  <span>Endodontic specialist</span>
                </div>
              </li>
              <li>
                <Scale className="list-icon" />
                <div>
                  <strong>Success Rate:</strong>
                  <span>Up to 90%</span>
                </div>
              </li>
              <li>
                <Microscope className="list-icon" />
                <div>
                  <strong>Visualization:</strong>
                  <span>4-25x magnification</span>
                </div>
              </li>
              <li>
                <Timer className="list-icon" />
                <div>
                  <strong>Recovery:</strong>
                  <span>Faster healing time</span>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </section>

      {/* Treatment Process */}
      <section className="process-section">
        <div className="container">
          <h2 className="section-title">5-Step Treatment Process</h2>
          <div className="process-timeline">
            <div className="timeline-item">
              <div className="timeline-icon">
                <Stethoscope />
              </div>
              <div className="timeline-content">
                <h3>Step 1: Local Anesthesia</h3>
                <p>Comfortable administration of local anesthesia based on individual needs</p>
              </div>
            </div>

            <div className="timeline-item">
              <div className="timeline-icon">
                <ArrowUpDown />
              </div>
              <div className="timeline-content">
                <h3>Step 2: Pulp Chamber Access</h3>
                <p>Precise opening of the infected pulp chamber under microscopic guidance</p>
              </div>
            </div>

            <div className="timeline-item">
              <div className="timeline-icon">
                <Zap />
              </div>
              <div className="timeline-content">
                <h3>Step 3: Infection Removal</h3>
                <p>Thorough cleaning using ultrasonic instruments and specialized techniques</p>
              </div>
            </div>

            <div className="timeline-item">
              <div className="timeline-icon">
                <Shield />
              </div>
              <div className="timeline-content">
                <h3>Step 4: Canal Sealing</h3>
                <p>Complete sealing with biomedical materials to prevent bacterial invasion</p>
              </div>
            </div>

            <div className="timeline-item">
              <div className="timeline-icon">
                <Syringe />
              </div>
              <div className="timeline-content">
                <h3>Step 5: Final Restoration</h3>
                <p>Protection with crown or permanent restoration to prevent fractures</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Key Benefits */}
      <section className="benefits-section container">
        <h2 className="section-title">Why Choose Microendodontic Treatment</h2>
        <div className="benefits-grid">
          <div className="benefit-card">
            <Microscope className="benefit-icon" />
            <h3>Enhanced Precision</h3>
            <p>
              German professional microscope technology enables precise visualization 
              of complex root canal structures.
            </p>
          </div>

          <div className="benefit-card">
            <Shield className="benefit-icon" />
            <h3>Minimally Invasive</h3>
            <p>
              Preserves more natural tooth structure while ensuring thorough 
              cleaning of infected areas.
            </p>
          </div>

          <div className="benefit-card">
            <Timer className="benefit-icon" />
            <h3>Faster Recovery</h3>
            <p>
              Advanced techniques and better precision lead to reduced post-operative 
              recovery time.
            </p>
          </div>

          <div className="benefit-card">
            <CheckCircle2 className="benefit-icon" />
            <h3>Higher Success Rate</h3>
            <p>
              Significantly improved treatment outcomes compared to conventional 
              methods.
            </p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Dto43d2;